import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=b876b314&scoped=true&"
import script from "./collect.vue?vue&type=script&lang=js&"
export * from "./collect.vue?vue&type=script&lang=js&"
import style0 from "./collect.vue?vue&type=style&index=0&id=b876b314&prod&lang=css&"
import style1 from "./collect.vue?vue&type=style&index=1&id=b876b314&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b876b314",
  null
  
)

export default component.exports